if (document.querySelector('#cv-input')) {
    document.addEventListener("DOMContentLoaded", function() {
        const fileInput = document.getElementById('cv-input');
        const fileLabel = document.getElementById('file-label');
        const uploadButton = document.getElementById('upload-button');
    
        // Nasłuchiwanie kliknięcia na przycisk
        uploadButton.addEventListener('click', function() {
            fileInput.click();
        });
    
        // Nasłuchiwanie zmiany na polu pliku
        fileInput.addEventListener('change', function() {
            if (fileInput.files.length > 0) {
                // Usunięcie całego tekstu i spanów z labela
                fileLabel.innerHTML = '';
                // Wstawienie nazwy wybranego pliku do labela
                fileLabel.textContent = fileInput.files[0].name;
            } else {
                // Przywrócenie domyślnego tekstu, jeśli plik nie został wybrany
                fileLabel.innerHTML = 'Dołącz CV<span class="inquiry-form__star">*</span>';
            }
        });
    });
}